/**
 * RRM — Reporting Metrics (Executive).
 *
 * Default export renders the RRM route tree so App.tsx wiring stays unchanged.
 */

import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import { ExecHome } from './ExecHome';
import { ScheduledExport } from './ScheduledExport';
import './rrm.css';

export default function RRM(): JSX.Element {
  return (
    <Routes>
      <Route index element={<ExecHome />} />
      <Route path="admin/schedule" element={<ScheduledExport />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
